import { DWTimeline } from 'src/components/timeline';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWTimeline.displayName, DWTimeline);

export default DWTimeline;

export { DWTimeline };
